import { render, staticRenderFns } from "./PriceAndMarginDashboard.vue?vue&type=template&id=8f6decfa&scoped=true"
import script from "./PriceAndMarginDashboard.vue?vue&type=script&lang=js"
export * from "./PriceAndMarginDashboard.vue?vue&type=script&lang=js"
import style0 from "./PriceAndMarginDashboard.vue?vue&type=style&index=0&id=8f6decfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6decfa",
  null
  
)

export default component.exports